/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusDownLeftIcon64Regular = forwardRef('ArrowDRadiusDownLeftIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M54 12.5C54 24.926 43.926 35 31.5 35H9.8c.19-.448.47-.867.838-1.23l14.914-14.702a1.5 1.5 0 1 0-2.106-2.136L8.533 31.634a6.833 6.833 0 0 0 0 9.733l14.914 14.701a1.5 1.5 0 0 0 2.106-2.136L10.639 39.23A3.822 3.822 0 0 1 9.8 38H31.5C45.583 38 57 26.583 57 12.5v-2a1.5 1.5 0 0 0-3 0v2Z" })));
});
